import { render, staticRenderFns } from "./ClassifiersModal.vue?vue&type=template&id=62b6e017"
import script from "./ClassifiersModal.vue?vue&type=script&lang=js"
export * from "./ClassifiersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports